import { render, staticRenderFns } from "./buySMS.vue?vue&type=template&id=3a53b0bb&scoped=true&"
import script from "./buySMS.vue?vue&type=script&lang=js&"
export * from "./buySMS.vue?vue&type=script&lang=js&"
import style0 from "./buySMS.vue?vue&type=style&index=0&id=3a53b0bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53b0bb",
  null
  
)

export default component.exports